import { createSlice } from '@reduxjs/toolkit';

import { QuestionnaireData, QuestionnaireStatus } from 'utils/QuestionnaireAPI';

import type { PayloadAction } from '@reduxjs/toolkit';

export interface QuestionnaireState {
    questionnaries: Array<QuestionnaireStatus> | null
    openedQuestionnarie: QuestionnaireData | null
    openedCloseSurveyModal: boolean
    temporaryLinkText: string
    openedErrorSurveyModal: boolean
}

const initialState: QuestionnaireState = {
    questionnaries: null,
    openedQuestionnarie: null,
    openedCloseSurveyModal: false,
    temporaryLinkText: '',
    openedErrorSurveyModal: false,
};

export type GroupedQuestionnaires = { [groupName: string]: QuestionnaireStatus[] };

export const questionnaireSlice = createSlice({
    name: 'questionary',
    initialState,
    reducers: {
        setQuestionnaries: (state, action: PayloadAction<QuestionnaireStatus[]>) => {
            state.questionnaries = action.payload;
        },
        setOpenedQuestionnaire: (state, action: PayloadAction<QuestionnaireData | null>) => {
            state.openedQuestionnarie = action.payload;
        },
        setOpenedCloseSurveyModal: (state, action: PayloadAction<boolean>) => {
            state.openedCloseSurveyModal = action.payload;
        },
        setTemporaryLinkText: (state, action: PayloadAction<string>) => {
            state.temporaryLinkText = action.payload;
        },
        setOpenedErrorSurveyModal: (state, action: PayloadAction<boolean>) => {
            state.openedErrorSurveyModal = action.payload;
        },
    },
});

export const { setQuestionnaries, setOpenedQuestionnaire, setOpenedCloseSurveyModal, setTemporaryLinkText, setOpenedErrorSurveyModal } = questionnaireSlice.actions;

export default questionnaireSlice.reducer;